const logos = [
  'Botequim da Marina',
  'Pizzaria do Bairro',
  'Sushi Nakamura',
  'Cantina Bella',
  'Churrascaria Dom',
  'Hamburgueria 73',
  'Bar do Zé',
  'Café Paulista',
  'Tapiocaria Sol',
  'Açaí Tropical',
]

const repeated = [...logos, ...logos]

export default function LogosStrip() {
  return (
    <div className="bg-white border-t border-b border-neutral-100 py-5 overflow-hidden">
      <p className="text-[10px] uppercase tracking-[2px] text-neutral-300 font-semibold text-center mb-4">
        Confiado por restaurantes em todo o Brasil
      </p>
      <div className="relative flex overflow-hidden">
        <div
          className="absolute left-0 top-0 bottom-0 w-16 z-10 pointer-events-none"
          style={{ background: 'linear-gradient(to right, #fff, transparent)' }}
        />
        <div
          className="absolute right-0 top-0 bottom-0 w-16 z-10 pointer-events-none"
          style={{ background: 'linear-gradient(to left, #fff, transparent)' }}
        />
        <div className="flex gap-10 animate-marquee whitespace-nowrap">
          {repeated.map((name, i) => (
            <span
              key={i}
              className="text-[12px] font-extrabold text-neutral-200 tracking-tight shrink-0 select-none"
            >
              {name}
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}
